import { defineMessages } from 'react-intl'

export default defineMessages({
    "business": {
        "defaultMessage": "Business",
        "id": "src.HomePage.LeftMenu.business"
    },
    "create": {
        "defaultMessage": "CREATE",
        "id": "src.HomePage.LeftMenu.create"
    },
    "logout": {
        "defaultMessage": "LOGOUT",
        "id": "src.HomePage.LeftMenu.logout"
    },
    "profile": {
        "defaultMessage": "PROFILE",
        "id": "src.HomePage.LeftMenu.profile"
    },
})

